module.exports = __webpack_public_path__ + "static/quiz_stage_9_bg_mobile-87171b923db2b9c4358454a5f390ec51.svg";